<!-- START DISPATCH HEADER -->
<div class="row pt-0">
    <div class="col-12">
        <ngx-loading [show]="loadingIndicator"></ngx-loading>

        <div class="row pt-0 pb-3">
            <div class="col-12">
                <!-- COLUMNS, SHOW SUMMARY/FILTERS, AND PRINT BUTTON-->


                <button type="button" class="btn btn-secondary btn-sm dropdown-toggle mb-1 mr-1" data-toggle="dropdown" *ngIf="loadingIndicator == false"
                aria-haspopup="true" aria-expanded="false" placement="bottom" ngbTooltip="Add">
                <span class="sr-only">Add</span>
                <i class="fa fa-lg fa-plus"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp;Add</span>
                </button>
                <div class="dropdown-menu fs-12" *ngIf="loadingIndicator == false">
                    <a  (click)="openModalAddChangeover()" [hidden]="getTotalJobsForChangeover() < 2" class="dropdown-item"
                        href="javascript:void(0);">Add Changeover</a>
                    <a  (click)="gotoAddDispatch()" class="dropdown-item"
                        href="javascript:void(0);" *ngIf="isEnabled('Linehaul Dispatch')">Dispatch New Job</a>
                </div>

                <button type="button" class="btn btn-sm btn-secondary mb-1 mr-1" (click)="print()" placement="bottom"
                    ngbTooltip="Print List">
                    <i class="fa fa-lg fa-print"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp;
                        Print</span>
                </button>
            
                
                <div class="btn-group mr-1">
                    <button type="button" class="btn btn-sm btn-secondary dropdown-toggle mb-1" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false" [disabled]="count < 1" placement="bottom"
                        ngbTooltip="Export List">
                        <i class="fa fa-lg fa-download"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp;
                            Export</span>
                    </button>
                    <div class="dropdown-menu fs-12">
                        <a (click)="dispatch_exportToCSV()" class="dropdown-item" href="javascript:void(0);">Export to
                            CSV</a>
                        <a (click)="dispatch_exportToExcel()" class="dropdown-item" href="javascript:void(0);">Export to
                            Excel</a>
                        <a (click)="dispatch_exportToPDF()" class="dropdown-item" href="javascript:void(0);">Export to
                            PDF</a>
                    </div>
                </div>

                <button type="button" [ngClass]="(showFilters)?'btn-success':'btn-secondary'" class="btn btn-sm mb-1 mr-1"
                    (click)="toggleFilters()" placement="bottom" ngbTooltip="Filter List">
                    <i class="fa fa-lg fa-filter"></i>
                    <span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Filter </span>
                </button> 

                <div class="btn-group mr-1">
                    <button type="button" class="btn btn-secondary btn-sm dropdown-toggle mb-1 mr-1" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false" placement="bottom" ngbTooltip="Show/Hide Columns">
                        <span class="sr-only">Toggle Dropdown</span>
                        <i class="fa fa-lg fa-check-square-o"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp;
                            Columns</span>
                    </button>
                    <div class="dropdown-menu fs-12" style="width: 350px;">
                        <div class="row pt-2 pb-2 pr-2 pl-2">
                            <div class="col-md-6">
                                <input type="checkbox" name="manifestWeekNo" [(ngModel)]="showWeekNo"> Week no.<br />
                                <input type="checkbox" name="manifestCtrlNo" [(ngModel)]="showjobManifestlNo"> Job Manifest Number<br />
                                <input type="checkbox" name="manifestCtrlNo" [(ngModel)]="showjobConnoteNo"> Job Connote Number<br />
                                <input type="checkbox" name="manifestRunStatus" [(ngModel)]="showRunStatus"> Status<br />
                                <input type="checkbox" name="manifestRunType" [(ngModel)]="showRunType"> Job Type<br />
                                <input type="checkbox" name="manifestRunDriver" [(ngModel)]="showRunDriver"> Driver<br />
                                <input type="checkbox" name="manifestRunEquipment" [(ngModel)]="showRunEquipment"> Equipment<br />
                                <!-- <input type="checkbox" name="manifestLinehaulType" [(ngModel)]="showLinehaulType"> Linehaul Type<br /> -->
                                <input type="checkbox" name="manifestSDPFile" [(ngModel)]="showSDPFile"> SDP File<br />
                                <input type="checkbox" name="manifestTripsheetFile" [(ngModel)]="showTripsheetFile"> Tripsheet File<br />
                                <input type="checkbox" name="manifestChangeoverRun" [(ngModel)]="showChangeoverRun"> Changeover<br />
                                <input type="checkbox" name="manifestTotalKlms" [(ngModel)]="showTotalKlms"> Total Distance<br />
                                <input type="checkbox" name="manifestTotalDriving" [(ngModel)]="showTotalDriving"> Total Driving Hours<br />
                                <input type="checkbox" name="manifestDepartureDate" [(ngModel)]="showDepartureDate"> Departure Date<br />
                                <input type="checkbox" name="manifestDepartureTime" [(ngModel)]="showDepartureTime"> Departure Time<br />
                                <input type="checkbox" name="manifestArrivalDate" [(ngModel)]="showArrivalDate"> Arrival Date<br />
                                <input type="checkbox" name="manifestArrivalTime" [(ngModel)]="showArrivalTime"> Arrival Time<br />
                            </div>
                        </div>
                    </div>
                </div>

                <span *ngIf="dateDropdown=='range'" class="pull-right ml-0 pl-0">&nbsp;
                    <input type="text" width="120" class="mb-1 ml-0" class="dateRangeInput" matInput
                        ngxDaterangepickerMd [locale]="locale"  startKey="start" endKey="end" [(ngModel)]="jobDateRange" (ngModelChange)="processDateRange()"
                        name="daterange" [autoApply]="true" opens="left" drops="down"/>
                </span>


                <select [(ngModel)]="dateDropdown" (ngModelChange)="onChangeDateDropdown($event)"
                    class="input-sm dateFilter  btn btn-sm  btn-secondary mb-1 mr-1 pull-right">
                    <option value="all">All dates</option>
                    <option value="today">Today</option>
                    <option value="week">This Week</option>
                    <option value="month">This Month</option>
                    <option value="year">This Year</option>
                    <option value="7">Last 7 days</option>
                    <option value="14">Last 14 days</option>
                    <option value="30">Last 30 days</option>
                    <option value="60">Last 60 days</option>
                    <option value="90">Last 90 days</option>
                    <option value="range">Custom date range</option>
                </select>

                <select [(ngModel)]="statusDropdown" (ngModelChange)="onChangeStatusDropdown($event)"
                    class="dateFilter  btn btn-sm  btn-secondary mb-1 mr-1 pull-right">
                    <option value="current">Current Jobs</option>
                    <option value="completed">Completed</option>
                    <!-- <option value="forinvoice">For Invoice</option> -->
                    <option value="cancelled">Cancelled</option>
                    <option value="all">All Status</option>
                </select>
            </div> <!-- COLUMNS, SHOW SUMMARY/FILTERS, AND PRINT BUTTON-->
        </div>
        <!-- END DISPATCH HEADER -->

        <!-- START OF GRID TABLE -->
        <div *ngIf="type=='grid'" class="row pt-0"> <br />
            <div *ngFor="let row of dispatchRows | DispatchSearchPipe: searchText | paginate: { itemsPerPage: 12, currentPage: p }; let i = index;"
                class="col-xl-4 col-lg-6 mb-4">
                <div class="flip">
                    <div class="content">
                        <div class="front">
                            <div class="card border-0 box-shadow rounded-0">
                                <div class="card-header border-0 rounded-0 text-muted">
                                    <h5 class="mb-0">
                                        {{row.control_no}}
                                    </h5>
                                    <div class="widget-controls">
                                        <a (click)="operations(row, 'view')" href="javascript:void(0);" class="transition"><i class="fa fa-book"></i></a>
                                        <a (click)="openCancelDispatchModal(row)" href="javascript:void(0);" class="transition"><i class="fa fa-stop-circle"></i></a>
                                    </div>
                                </div>
                                <div class="card-body pt-3">
                                    <div class="media">
                                        <div class="media-body">
                                            <div class="row">
                                                <div class="col-8 text-gray  pr-0 text-truncate">
                                                    Job Type: 
                                                    <span *ngIf="row.run_type_id == 1" title="Local">Local</span>
                                                    <span *ngIf="row.run_type_id == 2" title="Linehaul">Linehaul</span>
                                                    <span *ngIf="row.run_type_id == 3" title="Empty Run">Empty Run</span>
                                                    <span *ngIf="row.run_type_id == 4" title="Towhaul">Towhaul</span>
                                                </div>
                                                <!-- <div class="col-8 text-gray  pr-0 text-truncate">
                                                    Load Type:
                                                    <span *ngIf="row.linehaul_type == 'ftl'" title="Full Truckload">Full Truckload</span>
                                                    <span *ngIf="row.linehaul_type == 'ltl'" title="Less-than Truckload">Less-than Truckload</span>
                                                </div> -->
                                                <div class="col-8 text-gray  pr-0 text-truncate">
                                                    Status:
                                                    <span *ngIf="row.run_status_id == 1" title="Pending">Pending</span>
                                                    <span *ngIf="row.run_status_id == 2" title="Dispatched">Dispatched</span>
                                                    <span *ngIf="row.run_status_id == 3" title="Processing">Processing</span>
                                                    <span *ngIf="row.run_status_id == 4" title="Completed">Completed</span>
                                                    <span *ngIf="row.run_status_id == 5" title="Cancelled">Cancelled</span>
                                                    <span *ngIf="row.run_status_id == 6" title="Withdrawn">Withdrawn</span>
                                                    <span *ngIf="row.run_status_id == 7" title="Subcontracted">Subcontracted</span>
                                                    <span *ngIf="row.run_status_id == 8" title="Draft Plan">Draft Plan</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- END OF GRID TABLE -->

        <!-- START OF PAGINATION -->
        <div class="row pt-0" *ngIf="type=='grid'">
            <div class="col-12">
                <div class="bg-white text-center">
                    <pagination-controls autoHide="true" (pageChange)="p = $event" maxSize="10"></pagination-controls>
                </div>        
            </div>
        </div>
        <!-- END OF PAGINATION -->

        <!-- START OF LIST TABLE -->
        <div *ngIf="type=='list'" class="row pt-0">
            <div class="col-md-12">
                Total Items: <span style="color: rgb(23, 98, 141);">{{ (totalItems != null) ? (totalItems) :
                    "0"}}</span> |

                <!-- <a (click)="onClickJobType('Local');"><span [hidden]="filterRunType != 'Local'"><i
                            class="fa fa-check"></i>&nbsp;</span>Local:</a> <span style="color: rgb(23, 98, 141);">
                    {{ (totalLocal !== null) ? (totalLocal) : "0"}}</span> | -->
                <a (click)="onClickJobType('Linehaul');"><span [hidden]="filterRunType != 'Line Haul'"><i
                            class="fa fa-check"></i>&nbsp;</span>Linehaul:</a> <span style="color: rgb(23, 98, 141);">
                    {{ (totalLinehaul !== null) ? (totalLinehaul) : "0"}}</span>
                |
                <a (click)="onClickJobType('Empty Run');"><span [hidden]="filterRunType != 'Empty Run'"><i
                            class="fa fa-check"></i>&nbsp;</span>Empty Run:</a> <span style="color: rgb(23, 98, 141);">
                    {{ (totalEmptyRun !== null) ? (totalEmptyRun) : "0"}}</span> |&nbsp;
                <a (click)="onClickJobType('PUD');"><span [hidden]="filterRunType != 'PUD'"><i
                            class="fa fa-check"></i>&nbsp;</span>PUD:</a> <span style="color: rgb(23, 98, 141);">
                        {{ (totalWarehouse !== null) ? (totalWarehouse) : "0"}}</span>&nbsp;|&nbsp;
                <a (click)="onClickJobType('Tow Haul');"><span [hidden]="filterRunType != 'Tow Haul'"><i
                            class="fa fa-check"></i>&nbsp;</span>Tow Haul:</a> <span style="color: rgb(23, 98, 141);">
                    {{ (totalTowhaul !== null) ? (totalTowhaul) : "0"}}</span>&nbsp;|&nbsp;
                <a (click)="onClickJobType('Changeover');"><span [hidden]="filterRunType != 'Changeover'"><i
                            class="fa fa-check"></i>&nbsp;</span>Changeover:</a> <span style="color: rgb(23, 98, 141);">
                    {{ (totalChangeover !== null) ? (totalChangeover) : "0"}}</span>&nbsp;&nbsp;
                <!-- Reset Filters -->
                <a (click)="resetFilters()" container="body" placement="top" ngbTooltip="Reset Filter"><i
                    class="fa fa-rotate-left"></i></a>


                <a (click)="onClickStatus('Cancelled');" class="badge badge-pill badge-cancelled pull-right">
                    <i class="fa fa-check" [hidden]="filterRunStatus != 'Cancelled'"></i>
                    Cancelled
                </a>
                <a (click)="onClickStatus('Completed');" class="badge badge-pill is-line-dispatch-completed pull-right">
                    <i [hidden]="filterRunStatus != 'Completed'" class="fa fa-check"></i>
                    Completed
                </a>
                <a (click)="onClickStatus('Processing');" class="badge badge-pill badge-processing pull-right">
                    <i [hidden]="filterRunStatus != 'Processing'" class="fa fa-check"></i>
                    Processing
                </a>
                <a (click)="onClickStatus('Pending');" class="badge badge-pill badge-pending pull-right">
                    <i [hidden]="filterRunStatus != 'Pending'" class="fa fa-check"></i>
                    Pending
                </a>
            </div>
            <div class="col-md-12">
                <ngx-datatable *ngIf="!loadingIndicator" 
                    [loadingIndicator]="loadingIndicator"
                    class="material" 
                    [rows]="dispatchRows" 
                    [columnMode]="'force'" 
                    [headerHeight]="30" 
                    [footerHeight]="40" 
                    [rowHeight]="'auto'" 
                    [limit]="30" 
                    [selectionType]="'single'"
                    [scrollbarH]="true"
                    [headerHeight]="showFilters?50:30">
                    <ngx-datatable-column prop="id" name="Operations" headerClass="header" [width]="120"
                        [cellClass]="getCellClass">
                        <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                            <div style="padding-right:20px">
                                <a title="Details" (click)="operations(row, 'view')"><i class="fa fa-lg fa-book"></i>&nbsp;</a>
                                <a *ngIf="![4, 5, 6, 7].includes(row.run_status_id)" title="Edit" [routerLink]="['/dispatch/editor']" [queryParams]="{ id: row.id }"><i class="fa fa-fw fa-pencil"></i></a>
                                <a *ngIf="row.run_status_id == 1" title="Cancel Dispatch" (click)="openCancelDispatchModal(row)"><i class="fa fa-lg fa-stop-circle"></i>&nbsp;</a>
                                <a  *ngIf="row.changeover_run_id > 0 && row.run_type_id ==2 && row.run_status_id <4 && row.release == false && row.is_released == 0" title="Undo Changeover" (click)="openUndoChangeover(row)">
                                    <i class="fa fa-lg fas fa-undo"></i>&nbsp;</a>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column prop="manifest_week" name="Week #" headerClass="header" [cellClass]="getCellClass" *ngIf="showWeekNo">
                        <ng-template let-column="column" let-row="row" let-sort="sortfn" ngx-datatable-header-template>
                            <span>{{column.name}}</span>
                            <span *ngIf="showFilters">
                                <input type="text" [(ngModel)]="filterWeekNo" style="height:17px" 
                                    class="pt-1 pb-0 mt-0 mb-0 input-sm form-control form-control-sm"
                                    (keyup)="updateFilter()" />
                            </span>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column prop="control_no" name="Manifest No." headerClass="header" [cellClass]="getCellClass" *ngIf="showjobManifestlNo">
                        <ng-template let-column="column" let-row="row" let-sort="sortfn" ngx-datatable-header-template>
                            <span>{{column.name}}</span>
                            <span *ngIf="showFilters">
                                <input type="text" [(ngModel)]="filterManifestNo" style="height:17px" 
                                    class="pt-1 pb-0 mt-0 mb-0 input-sm form-control form-control-sm"
                                    (keyup)="updateFilter()" />
                            </span>
                        </ng-template>
                        <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                            <span *ngIf="row.changeover_run_id != null" class="badge badge-pill badge-warning"
                            placement="bottom" ngbTooltip="Changeover">C</span>&nbsp;
                            <span>{{row.control_no}}</span>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column prop="run_plan_activities" name="Connote No." headerClass="header" [cellClass]="getCellClass" *ngIf="showjobConnoteNo">
                        <ng-template let-column="column" let-row="row" let-sort="sortfn" ngx-datatable-header-template>
                            <span>{{column.name}}</span>
                            <span *ngIf="showFilters">
                                <input type="text" [(ngModel)]="filterConnoteNo" style="height:17px" 
                                    class="pt-1 pb-0 mt-0 mb-0 input-sm form-control form-control-sm"
                                    (keyup)="updateFilter()" />
                            </span>
                        </ng-template>
                        <ng-template let-value="value" let-row="row" ngx-datatable-cell-template >
                            <ng-container *ngFor="let activity of row.run_plan_activities; let lastItem = last;">
                                {{activity.control_no}}<span *ngIf="!lastItem">,&nbsp;</span>
                            </ng-container>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column prop="run_status" name="Status" headerClass="header" [cellClass]="getCellClass" *ngIf="showRunStatus">
                        <ng-template let-column="column" let-row="row" let-sort="sortfn" ngx-datatable-header-template>
                            <span>{{column.name}}</span>
                            <span *ngIf="showFilters">
                                <input type="text" [(ngModel)]="filterRunStatus" style="height:17px" 
                                    class="pt-1 pb-0 mt-0 mb-0 input-sm form-control form-control-sm"
                                    (keyup)="updateFilter()" />
                            </span>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column prop="run_type" name="Job Type" headerClass="header" [cellClass]="getCellClass"
                        *ngIf="showRunType">
                        <ng-template let-column="column" let-row="row" let-sort="sortfn" ngx-datatable-header-template>
                            <span>{{column.name}}</span>
                            <span *ngIf="showFilters">
                                <input type="text" [(ngModel)]="filterRunType" style="height:17px" 
                                    class="pt-1 pb-0 mt-0 mb-0 input-sm form-control form-control-sm"
                                    (keyup)="updateFilter()" />
                            </span>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column prop="drivers" name="Driver" headerClass="header" [cellClass]="getCellClass"
                        *ngIf="showRunDriver">
                        <ng-template let-column="column" let-row="row" let-sort="sortfn" ngx-datatable-header-template>
                            <span>{{column.name}}</span>
                            <span *ngIf="showFilters">
                                <input type="text" [(ngModel)]="filterRunDriver" style="height:17px" 
                                    class="pt-1 pb-0 mt-0 mb-0 input-sm form-control form-control-sm"
                                    (keyup)="updateFilter()" />
                            </span>
                        </ng-template>
                        <ng-template let-value="value" let-row="row" ngx-datatable-cell-template >
                            <span *ngIf="row.drivers?.length == 2">
                                <span *ngIf="row.drivers[0]?.first_name != null && row.drivers[0]?.last_name != null;else noDriver1Name">
                                    {{row.drivers[0]?.first_name}} {{row.drivers[0]?.last_namxe}} 
                                </span>
                                <ng-template #noDriver1Name>
                                    <span>-</span>
                                </ng-template>
                                <span *ngIf="row.drivers[0]?.first_name != null && row.drivers[0]?.last_name != null">
                                    & 
                                </span>
                                <span *ngIf="row.drivers[1]?.first_name != null && row.drivers[1]?.last_name != null;else noDriver2Name">
                                    {{row.drivers[1]?.first_name}} {{row.drivers[1]?.last_name}}
                                </span>
                                <ng-template #noDriver2Name>
                                    <span>-</span>
                                </ng-template>
                            </span>
                            <span *ngIf="row.drivers?.length == 1">
                                <span *ngIf="row.drivers[0]?.first_name != null || row.drivers[0]?.last_name != null;else noDriverName">
                                    {{row.drivers[0]?.first_name}} {{row.drivers[0]?.last_name}}
                                </span>
                                <ng-template #noDriverName>
                                    <span>-</span>
                                </ng-template>
                            </span>
                            <span *ngIf="row.drivers?.length == 0">-</span>
                        </ng-template>
                    </ngx-datatable-column>


                    <ngx-datatable-column prop="equipment" name="Equipment" headerClass="header" [cellClass]="getCellClass"
                    *ngIf="showRunEquipment">
                        <ng-template let-column="column" let-row="row" let-sort="sortfn" ngx-datatable-header-template>
                            <span>{{column.name}}</span>
                            <span *ngIf="showFilters">
                                <input type="text" [(ngModel)]="filterRunEquipments" style="height:17px" 
                                    class="pt-1 pb-0 mt-0 mb-0 input-sm form-control form-control-sm"
                                    (keyup)="updateFilter()" />
                            </span>
                        </ng-template>
                        <ng-template let-value="value" let-row="row" ngx-datatable-cell-template >
                            <ng-container *ngFor="let equipment of row.equipments; let lastItem = last;">
                                {{equipment.rego}}<span *ngIf="!lastItem">,&nbsp;</span>
                            </ng-container>
                        </ng-template>
                    </ngx-datatable-column>
                    

                    <ngx-datatable-column prop="sdp_file" name="SDP File" headerClass="header" [cellClass]="getCellClass"
                        *ngIf="showSDPFile">
                        <ng-template let-column="column" let-row="row" let-sort="sortfn" ngx-datatable-header-template>
                            <span>{{column.name}}</span>
                            <span *ngIf="showFilters">
                                <input type="text" [(ngModel)]="filterSDPFile" style="height:17px" 
                                    class="pt-1 pb-0 mt-0 mb-0 input-sm form-control form-control-sm"
                                    (keyup)="updateFilter()" />
                            </span>
                        </ng-template>
                        <ng-template let-value="value" let-row="row" ngx-datatable-cell-template >
                            <span *ngIf="row.sdp_file == 'No File';else displaySDP">No File</span>
                            <ng-template #displaySDP>
                                <span *ngIf="row.sdp_file?.length != 0" title="{{row.sdp_file}}">
                                    <a href="{{folderPath}}/sdp/{{row.sdp_file}}" target="_blank" >{{row.sdp_file}}</a>
                                </span>
                            </ng-template>
                            
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column prop="tripsheet_file" name="Tripsheet File" headerClass="header" [cellClass]="getCellClass" *ngIf="showTripsheetFile">
                        <ng-template let-column="column" let-row="row" let-sort="sortfn" ngx-datatable-header-template>
                            <span>{{column.name}}</span>
                            <span *ngIf="showFilters">
                                <input type="text" [(ngModel)]="filterTripsheetFile" style="height:17px" 
                                    class="pt-1 pb-0 mt-0 mb-0 input-sm form-control form-control-sm"
                                    (keyup)="updateFilter()" />
                            </span>
                        </ng-template>
                        <ng-template let-value="value" let-row="row" ngx-datatable-cell-template >
                            <span *ngIf="row.tripsheet_file == 'No File';else displayTripsheet">No File</span>
                            <ng-template #displayTripsheet>
                                <span *ngIf="row.tripsheet_file?.length != 0" title="{{row.tripsheet_file}}">
                                    <a href="{{folderPath}}/tripsheet/{{row.tripsheet_file}}" target="_blank">{{row.tripsheet_file}}</a>
                                </span>
                            </ng-template>
                            
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column prop="changeover_with" name="Changeover" headerClass="header" [cellClass]="getCellClass" *ngIf="showChangeoverRun">
                        <ng-template let-column="column" let-row="row" let-sort="sortfn" ngx-datatable-header-template>
                            <span>{{column.name}}</span>
                            <span *ngIf="showFilters">
                                <input type="text" [(ngModel)]="filterChangeover" style="height:17px" 
                                    class="pt-1 pb-0 mt-0 mb-0 input-sm form-control form-control-sm"
                                    (keyup)="updateFilter()" />
                            </span>
                        </ng-template>
                        <ng-template let-value="value" let-row="row" ngx-datatable-cell-template >
                            <span>{{row.changeover_with}}</span>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column prop="total_klms" name="Total Distance" headerClass="header" [cellClass]="getCellClass" *ngIf="showTotalKlms">
                        <ng-template let-column="column" let-row="row" let-sort="sortfn" ngx-datatable-header-template>
                            <span>{{column.name}} (Klms)</span>
                            <span *ngIf="showFilters">
                                <input type="text" [(ngModel)]="filterTotalKlms" style="height:17px" 
                                    class="pt-1 pb-0 mt-0 mb-0 input-sm form-control form-control-sm"
                                    (keyup)="updateFilter()" />
                            </span>
                        </ng-template>
                        <ng-template let-value="value" let-row="row" ngx-datatable-cell-template >
                            <span title="{{row.total_klms}}">{{row.total_klms}}</span>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column prop="drv_Hours" name="Total Driving Hours" headerClass="header" [cellClass]="getCellClass" *ngIf="showTotalDriving">
                        <ng-template let-column="column" let-row="row" let-sort="sortfn" ngx-datatable-header-template>
                            <span>{{column.name}}</span>
                            <span *ngIf="showFilters">
                                <input type="text" [(ngModel)]="filterDrivingHours" style="height:17px" 
                                    class="pt-1 pb-0 mt-0 mb-0 input-sm form-control form-control-sm"
                                    (keyup)="updateFilter()" />
                            </span>
                        </ng-template>
                        <ng-template let-value="value" let-row="row" ngx-datatable-cell-template >
                            <span title="{{row.drv_Hours}}">{{row.drv_Hours}}</span>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column prop="departure_date" name="Departure Date" headerClass="header" [cellClass]="getCellClass" *ngIf="showDepartureDate">
                        <ng-template let-column="column" let-row="row" let-sort="sortfn" ngx-datatable-header-template>
                            <span>{{column.name}}</span>
                            <span *ngIf="showFilters">
                                <input type="date" [(ngModel)]="filterDepartureDate" style="height:17px" 
                                    class="pt-1 pb-0 mt-0 mb-0 input-sm form-control form-control-sm"
                                    (keyup)="updateFilter()" />
                            </span>
                        </ng-template>
                        <ng-template let-value="value" let-row="row" ngx-datatable-cell-template >
                            <span *ngIf="row.departure_date == '' || row.departure_date == null" title="-">-</span>
                            <!-- <span *ngIf="row.departure_date?.length != 0" title="{{row.departure_date}}">{{row.departure_date| date:'dd MMM yyyy'}}</span> -->
                            <span *ngIf="row.departure_date?.length != 0" title="{{row.departure_date}}">{{row.departure_date}}</span>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column prop="departure_time" name="Departure Time" headerClass="header" [cellClass]="getCellClass" *ngIf="showDepartureTime">
                        <ng-template let-column="column" let-row="row" let-sort="sortfn" ngx-datatable-header-template>
                            <span>{{column.name}}</span>
                            <span *ngIf="showFilters">
                                <input type="time" [(ngModel)]="filterDepartureTime" style="height:17px" 
                                    class="pt-1 pb-0 mt-0 mb-0 input-sm form-control form-control-sm"
                                    (keyup)="updateFilter()" />
                            </span>
                        </ng-template>
                        <ng-template let-value="value" let-row="row" ngx-datatable-cell-template >
                            <span *ngIf="row.departure_time == '' || row.departure_time == null" title="-">-</span>
                            <!-- <span *ngIf="row.departure_time?.length != 0" title="{{row.departure_time}}">{{row.departure_time | date:'shortTime'}}</span> -->
                            <span *ngIf="row.departure_time?.length != 0" title="{{row.departure_time}}">{{row.departure_time}}</span>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column prop="arrival_date" name="Arrival Date" headerClass="header" [cellClass]="getCellClass" *ngIf="showArrivalDate">
                        <ng-template let-column="column" let-row="row" let-sort="sortfn" ngx-datatable-header-template>
                            <span>{{column.name}}</span>
                            <span *ngIf="showFilters">
                                <input type="date" [(ngModel)]="filterArrivalDate" style="height:17px" 
                                    class="pt-1 pb-0 mt-0 mb-0 input-sm form-control form-control-sm"
                                    (keyup)="updateFilter()" />
                            </span>
                        </ng-template>
                        <ng-template let-value="value" let-row="row" ngx-datatable-cell-template >
                            <span *ngIf="row.arrival_date == '' || row.arrival_date == null" title="-">-</span>
                            <!-- <span *ngIf="row.arrival_date?.length != 0" title="{{row.arrival_date}}">{{row.arrival_date| date:'dd MMM yyyy'}}</span> -->
                            <span *ngIf="row.arrival_date?.length != 0" title="{{row.arrival_date}}">{{row.arrival_date}}</span>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column prop="arrival_time" name="Arrival Time" headerClass="header" [cellClass]="getCellClass" *ngIf="showArrivalTime">
                        <ng-template let-column="column" let-row="row" let-sort="sortfn" ngx-datatable-header-template>
                            <span>{{column.name}}</span>
                            <span *ngIf="showFilters">
                                <input type="time" [(ngModel)]="filterArrivalTime" style="height:17px" 
                                    class="pt-1 pb-0 mt-0 mb-0 input-sm form-control form-control-sm"
                                    (keyup)="updateFilter()" />
                            </span>
                        </ng-template>
                        <ng-template let-value="value" let-row="row" ngx-datatable-cell-template >
                            <span *ngIf="row.arrival_time == '' || row.arrival_time == null" title="-">-</span>
                            <!-- <span *ngIf="row.arrival_time?.length != 0" title="{{row.arrival_time}}">{{row.arrival_time| date:'shortTime'}}</span> -->
                            <span *ngIf="row.arrival_time?.length != 0" title="{{row.arrival_time}}">{{row.arrival_time}}</span>
                        </ng-template>
                    </ngx-datatable-column>
                </ngx-datatable>
            </div>

        </div>
        <!-- END OF LIST TABLE -->

        <!-- START PRINT-->
        <div id="print-section" style="display:none">
            <table style="width:100%">
                <tr>
                    <!-- <th align="left" *ngIf="showImage">IMAGE</th> -->
                    <th *ngIf="showjobManifestlNo">JOB MANIFEST NUMBER</th>
                    <th *ngIf="showjobConnoteNo">JOB CONNOTE NUMBER</th>
                    <th *ngIf="showRunType">JOB TYPE</th>
                    <!-- <th *ngIf="showLinehaulType">LINEHAUL TYPE</th> -->
                    <th *ngIf="showRunStatus">STATUS</th>
                    <th *ngIf="showSDPFile">SDP FILE</th>
                    <th *ngIf="showTripsheetFile">TRIPSHEET FILE</th>
                    <th *ngIf="showChangeoverRun">CHANGEOVER</th>
                    <th *ngIf="showTotalKlms">TOTAL DISTANCE</th>
                    <th *ngIf="showTotalDriving">TOTAL DRIVING HOURS</th>
                    <th *ngIf="showDepartureDate">DEPARTURE DATE</th>
                    <th *ngIf="showDepartureTime">DEPARTURE TIME</th>
                    <th *ngIf="showArrivalDate">ARRIVAL DATE</th>
                    <th *ngIf="showArrivalTime">ARRIVAL TIME</th>
                </tr>
                <tr *ngFor="let row of dispatchRows">
                    <td *ngIf="showjobManifestlNo">{{row.control_no}}</td>
                    <td *ngIf="showjobConnoteNo">{{row.control_no}}</td>
                    <td *ngIf="showRunType">
                        <span *ngIf="row.run_type_id == 1" title="Local">Local</span>
                        <span *ngIf="row.run_type_id == 2" title="Linehaul">Linehaul</span>
                        <span *ngIf="row.run_type_id == 3" title="Empty Run">Empty Run</span>
                        <span *ngIf="row.run_type_id == 4" title="Towhaul">Towhaul</span>
                    </td>
                    <!-- <td *ngIf="showLinehaulType">
                        <span *ngIf="row.linehaul_type == '' || row.linehaul_type == null" title="-">-</span>
                        <span *ngIf="row.linehaul_type == 'ftl'" title="Full Truckload">Full Truckload</span>
                        <span *ngIf="row.linehaul_type == 'ltl'" title="Less-than Truckload">Less-than Truckload</span>
                    </td> -->
                    <td *ngIf="showRunStatus">
                        <span *ngIf="row.run_status_id == 1" title="Pending">Pending</span>
                        <span *ngIf="row.run_status_id == 2" title="Dispatched">Dispatched</span>
                        <span *ngIf="row.run_status_id == 3" title="Processing">Processing</span>
                        <span *ngIf="row.run_status_id == 4" title="Completed">Completed</span>
                        <span *ngIf="row.run_status_id == 5" title="Cancelled">Cancelled</span>
                        <span *ngIf="row.run_status_id == 6" title="Withdrawn">Withdrawn</span>
                        <span *ngIf="row.run_status_id == 7" title="Subcontracted">Subcontracted</span>
                        <span *ngIf="row.run_status_id == 8" title="Draft Plan">Draft Plan</span>
                    </td>
                    <td *ngIf="showSDPFile">
                        <span *ngIf="row.sdp_file == '' || row.sdp_file == null" title="-">-</span>
                        <span *ngIf="row.sdp_file?.length != 0" title="{{row.sdp_file}}">
                            <a href="{{url.rest}}/connotes/{{row.sdp_file}}" target="_blank" >{{row.sdp_file}}</a>
                        </span>
                    </td>
                    <td *ngIf="showTripsheetFile">
                        <span *ngIf="row.tripsheet_file == '' || row.tripsheet_file == null" title="-">-</span>
                        <span *ngIf="row.tripsheet_file?.length != 0" title="{{row.tripsheet_file}}">
                            <a href="{{url.rest}}/connotes/{{row.tripsheet_file}}" target="_blank" >{{row.tripsheet_file}}</a>
                        </span>
                    </td>
                    <td *ngIf="showChangeoverRun">
                        <span title="{{row.changeover_with}}">{{row.changeover_with}}</span>
                    </td>
                    <td *ngIf="showTotalKlms">{{row.total_klms}}</td>
                    <td *ngIf="showTotalDriving">{{row.total_driving_hours}}</td>
                    <td *ngIf="showDepartureDate">
                        <span *ngIf="row.departure_date == '' || row.departure_date == null" title="-">-</span>
                        <span *ngIf="row.departure_date?.length != 0" title="{{row.departure_date}}">{{row.departure_date}}</span>
                    </td>
                    <td *ngIf="showArrivalDate">
                        <span *ngIf="row.departure_time == '' || row.departure_time == null" title="-">-</span>
                        <span *ngIf="row.departure_time?.length != 0" title="{{row.departure_time}}">{{row.departure_time}}</span>
                    </td>
                    <td *ngIf="showDepartureTime">
                        <span *ngIf="row.arrival_date == '' || row.arrival_date == null" title="-">-</span>
                        <span *ngIf="row.arrival_date?.length != 0" title="{{row.arrival_date}}">{{row.arrival_date}}</span>
                    </td>
                    <td *ngIf="showArrivalTime">
                        <span *ngIf="row.arrival_time == '' || row.arrival_time == null" title="-">-</span>
                        <span *ngIf="row.arrival_time?.length != 0" title="{{row.arrival_time}}">{{row.arrival_time}}</span>
                    </td>
                    
                </tr>
            </table>
        </div>
        <!-- END PRINT -->
    </div>
</div>
<ng-template #cancelDispatchModal let-close="close">
    <div class="modal-header">
      <h5 class="modal-title font-weight-bold">Cancel Dispatched Job</h5>
      <button type="button" class="close" (click)="close()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
        <p><b>{{selectedrow.control_no}}</b>'s trip and the following connotes will be terminated:</p>
        <ul class="pl-4" *ngFor="let row of selectedrow?.run_plan_activities">
            <li>{{row.control_no}}</li>
        </ul>
        <p> Do you wish to proceed? </p>
    </div>
    <div class="modal-footer">
        <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
        <button type="button" class="btn btn-sm btn-danger" (click)="operations(selectedrow, 'cancelconnote')"
            [disabled]="spinner == true">Cancel Job and Connotes</button>
        <button type="button" class="btn btn-sm btn-danger" (click)="operations(selectedrow, 'cancel')"
            [disabled]="spinner == true">Cancel Job Only </button>
    </div>
</ng-template>

<ng-template #undoChangeoverModal let-close="close">
    <div class="modal-header">
      <h5 class="modal-title font-weight-bold">Undo Changeover</h5>
      <button type="button" class="close" (click)="close()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
        <p>Confirming this will remove all previous details for changeover. Do you wish to proceed? </p>
    </div>
    <div class="modal-footer">
        <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
        <button type="button" class="btn btn-sm btn-danger" (click)="undo(undo_changeover)"
            [disabled]="spinner == true">Yes</button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="close()">Cancel</button>
    </div>
</ng-template>

        <!---- addChangeoverModal ---->
 <ng-template #addChangeoverModal let-close="close">

    <div class="modal-header">
        <h5 class="modal-title">Add Changeover</h5>
        <button type="button" class="close" (click)="closeModal();close();">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">
        <div class="alert alert-warning fade show" role="alert">
            <label>Select Job 1:</label>
    
            <select  class="form-control form-control-sm" [(ngModel)]="firstRun"
            (change)="onSelectFirstJob(firstRun)">
                <option disabled selected value="">Select Job 1</option>
                <option *ngFor="let j of changeover_rows; let i=index" [value]="j.id">
                    {{j.control_no}}
                </option>
            </select><br />
    
            <label *ngIf="firstRunPoints">After:</label>
            <select *ngIf="firstRunPoints"  class="form-control form-control-sm">
                <option [value]="firstRunPoints[0].id">{{firstRunPoints[0].activity}} at {{firstRunPoints[0].location}}
                </option>
            </select> <br /> 

            <table class="table table-bordered" *ngIf="legData[0]?.length > 0 && route_done == false">
                <thead>
                    <tr class="table-active ">
                        <th width="70%">Route</th>
                        <th>Est. Distance</th>
                        <th>Est. Time</th>
                    </tr>
                </thead>

                <tbody *ngIf="legData[0]?.length > 0">
                    <tr>
                        <td>
                            <select [(ngModel)]="binding[0]" [ngModelOptions]="{standalone: true}" [value]='"test"' class="form-control form-control-sm">
                                <option *ngFor="let item of legData[0], let i = index" [defaultSelected]='i === 0' [value]="i">{{item['est_leg_route']}}</option>
                            </select>
                        </td>
                        <td>{{legData[0][binding[0]].est_total_klms}} klms</td>
                        <td>{{(legData[0][binding[0]].est_total_hrs_text).replace('"', '')}}</td>
                    </tr>
                </tbody>

                <tbody *ngIf="!legData[0]">
                    <tr>
                        <th scope="row"></th>
                        <td class="noroutes">No Routes</td>
                        <td></td>
                        <td></td>
                    </tr>
                </tbody>
            </table> 

            <table class="table table-bordered" *ngIf="runData[0]?.length > 0 && route_done1 == false">

                <thead>
                    <tr class="table-active ">
                        <th width="70%">Route</th>
                        <th>Est. Distance</th>
                        <th>Est. Time</th>
                    </tr>
                </thead>

                <tbody *ngIf="runData[0]?.length > 0">
                    <tr>
                        <td>
                            <select [(ngModel)]="binding1[0]" [ngModelOptions]="{standalone: true}" [value]='"test"' class="form-control form-control-sm">
                                <option *ngFor="let item of runData[0], let i = index" [defaultSelected]='i === 0' [value]="i">{{item['est_leg_route']}}</option>
                            </select>
                        </td>
                        <td>{{runData[0][binding1[0]].est_total_klms}} klms</td>
                        <td>{{(runData[0][binding1[0]].est_total_hrs_text).replace('"', '')}}</td>
                    </tr>
                </tbody>

                <tbody *ngIf="!runData">
                    <tr>
                        <th scope="row"></th>
                        <td class="noroutes">No Routes</td>
                        <td></td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="alert alert-gray fade show" role="alert">
    
            <div class="form-group form-group-sm">
                <div class="row">
                    <div class="col-md-4">
                        <label>Release Date:</label>
                        <my-date-picker name="date" [options]="myDatePickerOptions" [(ngModel)]="releaseDate" (ngModelChange)="checkDates()">
                        </my-date-picker>
                    </div>
                    <div class="col-md-4">
                        <h6>Start Time :</h6>
                        <ngb-timepicker [(ngModel)]="releaseStartTime" (ngModelChange)="checkDates()">
                        </ngb-timepicker>
                    </div> 
                    <div class="col-md-4">
                        <h6>Finish Time :</h6>
                        <ngb-timepicker [(ngModel)]="releaseFinishTime" (ngModelChange)="checkDates()">
                        </ngb-timepicker>
                        <!-- <small class="text-danger"  *ngIf="time1 == false" >*</small> -->
                    </div>  
                </div>
            </div> 

            <div class="form-group form-group-sm">
                <div class="row">
                    <div class="col-md-4">
                        <label>Collect Date:</label>
                        <my-date-picker name="date" [options]="myDatePickerOptions" [(ngModel)]="collectDate" (ngModelChange)="checkDates()">
                        </my-date-picker>
                    </div>
                    <div class="col-md-4">
                        <h6>Start Time :</h6>
                        <ngb-timepicker [(ngModel)]="collectStartTime" (ngModelChange)="checkDates()">
                        </ngb-timepicker>
                        <!-- <small class="text-danger"  *ngIf="time1 == false" >*</small><br>
                        <small class="text-danger"  *ngIf="time2 == false" >*</small> -->
                    </div> 
                    <div class="col-md-4">
                        <h6>Finish Time :</h6>
                        <ngb-timepicker [(ngModel)]="collectFinishTime" (ngModelChange)="checkDates()">
                        </ngb-timepicker>
                        <!-- <small class="text-danger"  *ngIf="time1 == false" >*</small> -->
                    </div>
                </div>
            </div> 

            <div class="form-group form-group-sm">
                <div class="row">
                    <div class="col-md-4"></div>
                    <div class="col-md-8">
                        <small class="mr-auto text-danger" *ngIf="!releaseDateCheck"><i>* Release Date <b>must not</b> exceed the Collect Date.</i><br></small>
                        <small class="mr-auto text-danger" *ngIf="!checkDatetime"><i>* Release start time  <b>must not</b> exceed the collect finish time</i></small>
                    </div>
                </div>
            </div>

            <div class="form-group" *ngIf="firstRun && secondRun">
                <label for="input-1"><span>Enter </span>Changeover Point</label>
                <ngx-geo-autocomplete  [class.required]="!hasLocationString()" [class.valid]="hasLocationString()" 
                    [userSettings]="userSettings" (componentCallback)="addChangeoverCallback($event)">
                </ngx-geo-autocomplete><br />
            </div><br /> 
            <br /> 

            <div class="row" *ngIf="showChangeoverAddressEntries">
                <div class="form-group col-md-4">
                    <label for="input-1">Street Number:</label>
                    <input type="text" class="form-control form-control-sm" [(ngModel)]="changeoverStreetNo">
                </div>
                <div class="form-group col-md-8">
                    <label for="input-1">Street:</label>
                    <input type="text" class="form-control form-control-sm" [(ngModel)]="changeoverStreet">
                </div>
            </div>

            <div class="row" *ngIf="showChangeoverAddressEntries">
                <div class="form-group col-md-4">
                    <label for="input-1">Suburb/City:</label>
                    <input type="text" class="form-control form-control-sm" [(ngModel)]="changeoverSuburb">
                </div>
    
                <div class="form-group col-md-4">
                    <label for="input-1">State:</label>
                    <input type="text" class="form-control form-control-sm" [(ngModel)]="changeoverState">
                </div>
                <div class="form-group col-md-4">
                    <label for="input-1">Postal Code:</label>
                    <input type="text" class="form-control form-control-sm" [(ngModel)]="changeoverPostalCode">
                </div>
            </div><br /> 

        </div>

        <div class="alert alert-warning fade show" role="alert">
            <label>Select Job 2:</label>
            <select class="form-control form-control-sm" [(ngModel)]="secondRun"
            (change)="onSelectSecondJob(secondRun)"> 
            <option disabled selected value="">Select Job 2</option>
                <option *ngFor="let j of changeover_rows; let i=index"  [value]="j.id" [disabled]="firstRun == j.id">{{j.control_no}}
                </option>
            </select>
            <br />
            <label *ngIf="secondRunPoints">After:</label> 
            <select *ngIf="secondRunPoints"  class="form-control form-control-sm">
                <option disabled value="">Select:</option>
                <option  [value]="secondRunPoints[0].id" [selected]="!secondRunPoints[1]">
                    {{secondRunPoints[0].activity}} at {{secondRunPoints[0].location}}
                </option>
            </select> <br />

            <table class="table table-bordered" *ngIf="legData[1]?.length > 0">
                <thead>
                    <tr class="table-active ">
                        <th width="70%">Route</th>
                        <th>Est. Distance</th>
                        <th>Est. Time</th>
                    </tr>
                </thead> 
                <tbody *ngIf="legData[1]?.length > 0">
                    <tr>
                        <td>
                            <select [(ngModel)]="binding[1]" [ngModelOptions]="{standalone: true}" [value]='"test"' class="form-control form-control-sm">
                                <option *ngFor="let item of legData[1], let i = index" [defaultSelected]='i === 0' [value]="i">{{item['est_leg_route']}}</option>
                            </select>
                        </td>
                        <td>{{legData[1][binding[1]].est_total_klms}} klms</td>
                        <td>{{(legData[1][binding[1]].est_total_hrs_text).replace('"', '')}}</td>
                    </tr>
        
                </tbody>
                <tbody *ngIf="!legData">
                    <tr>
                        <th scope="row"></th>
                        <td class="noroutes">No Routes</td>
                        <td></td>
                        <td></td>
                    </tr>
                    
                </tbody> 
            </table> 

            <table class="table table-bordered" *ngIf="runData[1]?.length > 0">
                <thead>
                    <tr class="table-active ">
                        <th width="70%">Route</th>
                        <th>Est. Distance</th>
                        <th>Est. Time</th>
                    </tr>
                    </thead> 

                <tbody *ngIf="runData[1]?.length > 0">
                    <tr>
                        <td>
                            <select [(ngModel)]="binding1[1]" [ngModelOptions]="{standalone: true}" [value]='"test"' class="form-control form-control-sm">
                                <option *ngFor="let item of runData[1], let i = index" [defaultSelected]='i === 0' [value]="i">{{item['est_leg_route']}}</option>
                            </select>
                        </td>
                        <td>{{runData[1][binding1[1]].est_total_klms}} klms</td>
                        <td>{{(runData[1][binding1[1]].est_total_hrs_text).replace('"', '')}}</td>
                    </tr>
                </tbody>

                

                <tbody *ngIf="!runData">
                    <tr>
                        <th scope="row"></th>
                        <td class="noroutes">No Routes</td>
                        <td></td>
                        <td></td>
                    </tr>
                </tbody> 
            </table>
        </div>
    </div>

    <div class="modal-footer">
        <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
        <button type="button" class="btn btn-sm btn-success" (click)="onSaveChangeover();close();" [disabled]="!hasLocationString() || !firstRun || !secondRun || checkDatetime == false || spinner == true || hasComputedRoutes()">Save</button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="closeModal();close()">Cancel</button>
    </div>
</ng-template>
        